module.exports = __webpack_public_path__ + "static/img/icon.ecc2da9.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/icon.ico
// module id = 1636
// module chunks = 6